"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newReferenceId = exports.randomSelection = exports.generateRandomColor = exports.generateRandomUri = exports.generateRandomDomain = exports.generateRandomEmail = exports.generateRandomString = exports.generateNewPassword = exports.randomBool = exports.randomNumberInInterval = exports.newUUID = void 0;
const uuid_1 = __importDefault(require("uuid"));
const uid_1 = __importDefault(require("uid"));
function newUUID() {
    return uuid_1.default.v4();
}
exports.newUUID = newUUID;
function randomNumberInInterval(from, to) {
    return Math.floor(Math.random() * (to - from) + from);
}
exports.randomNumberInInterval = randomNumberInInterval;
function randomBool() {
    return Math.random() < 0.5;
}
exports.randomBool = randomBool;
function generateNewPassword() {
    return uuid_1.default.v4().substring(0, 8);
}
exports.generateNewPassword = generateNewPassword;
function generateRandomString(length) {
    const uuidLength = 32;
    let randomString = "";
    const numberOfUuidsToGenerate = length / uuidLength + 1;
    for (let i = 0; i < numberOfUuidsToGenerate; i += 1) {
        randomString += uuid_1.default.v4().replace("-", "");
    }
    return randomString.substring(0, length);
}
exports.generateRandomString = generateRandomString;
function generateRandomEmail() {
    return `${generateRandomString(8)}@test.com`;
}
exports.generateRandomEmail = generateRandomEmail;
function generateRandomDomain() {
    return `${generateRandomString(8)}.${process.env.PORTALS_DOMAIN}`;
}
exports.generateRandomDomain = generateRandomDomain;
function generateRandomUri() {
    return `https://www.${generateRandomString(8)}.io`;
}
exports.generateRandomUri = generateRandomUri;
function generateRandomColor() {
    return `#${generateRandomString(6)}`;
}
exports.generateRandomColor = generateRandomColor;
function randomSelection(options) {
    const index = randomNumberInInterval(0, options.length);
    return options[index];
}
exports.randomSelection = randomSelection;
function newReferenceId(length, prefix) {
    const id = (0, uid_1.default)(length);
    const idPrefix = prefix ? `${prefix}-` : "";
    return `${idPrefix}${id}`.toUpperCase();
}
exports.newReferenceId = newReferenceId;
//# sourceMappingURL=randomizer.js.map